import classNames from 'classnames'
import { Status } from 'feature/statuses/types'
import { ReactNode } from 'react'
import { Button } from 'ui'
import { EmailStatus } from 'widget/EmailStatus'

import style from './MenuBlockWithIcon.module.scss'

type TMenuBlockWithIcon = {
  startIcon?: React.ReactNode
  disabled?: boolean
  endIcon?: React.ReactNode
  link?: string
  text: string | undefined
  status?: Status
  subText?: ReactNode
  statusText?: string
  'data-testid'?: string
}
// элемент меню с иконкой
export function MenuBlockWithIcon({
  startIcon,
  endIcon,
  link,
  text,
  subText,
  statusText,
  disabled,
  status,
  'data-testid': dataTestId,
}: TMenuBlockWithIcon) {
  return (
    <Button
      {...(link && { to: link })}
      type='button'
      variant='contained'
      color='secondary'
      disabled={disabled}
      className={style.menuBlockWithIcon}
      data-testid={dataTestId}
    >
      <div className={style.menuBlockWithIcon__leftPath}>
        {startIcon}
        <div
          className={classNames(
            style.menuBlockWithIcon__info,
            status?.length && style.menuBlockWithIcon__withStatus,
          )}
        >
          <div className={style.menuBlockWithIcon__texts}>
            <span
              className={classNames(
                style.menuBlockWithIcon__menuText,
                'default-text',
              )}
            >
              {text}
            </span>
            {subText && (
              <span
                className={classNames(
                  style.menuBlockWithIcon__subText,
                  'caption',
                )}
              >
                {subText}
              </span>
            )}
          </div>

          {statusText && status && text && (
            <EmailStatus status={status} statusText={statusText} />
          )}
        </div>
      </div>

      {endIcon}
    </Button>
  )
}

MenuBlockWithIcon.defaultProps = {
  subText: undefined,
  disabled: false,
  endIcon: undefined,
  status: undefined,
  link: undefined,
  statusText: undefined,
  'data-testid': undefined,
}
